export default async () => {
  const [{ default: pdfMake }, { default: pdfFonts }] = await Promise.all([
    import(/* webpackChunkName: "pdfmake", webpackPreload: true */ "pdfmake/build/pdfmake"),
    import(/* webpackChunkName: "pdfmake", webpackPreload: true */ "pdfmake/build/vfs_fonts"),
  ]);

  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const origin = window.location.origin;

  pdfMake.fonts = {
    Roboto: {
      normal: `${origin}/fonts/Roboto-Regular.ttf`,
      bold: `${origin}/fonts/Roboto-Bold.ttf`,
      italics: `${origin}/fonts/Roboto-Italic.ttf`,
      bolditalics: `${origin}/fonts/Roboto-BoldItalic.ttf`,
    },
    RobotoBold: {
      normal: `${origin}/fonts/Roboto-Bold.ttf`,
    },
    RobotoThin: {
      normal: `${origin}/fonts/Roboto-Thin.ttf`,
    },
  };

  return pdfMake;
};
